import script from "./ChassisSectionDW5.vue?vue&type=script&setup=true&lang=js"
export * from "./ChassisSectionDW5.vue?vue&type=script&setup=true&lang=js"

import "./ChassisSectionDW5.vue?vue&type=style&index=0&id=d4431aa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4431aa6"]])

export default __exports__